import { render, staticRenderFns } from "./EmailAge.vue?vue&type=template&id=59712594"
import script from "./EmailAge.vue?vue&type=script&lang=js"
export * from "./EmailAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports